import { Typography, Box } from '@mui/material';
import { IColumn } from 'packages/ui/Table';
import { formatBytes, formatDateTime } from '../helpers';

const COLUMNS_CONFIG: IColumn[] = [
  {
    name: 'email',
    header: {
      label: (ctx) => ctx.t('supervision.connected_users.table.email'),
    },
    value: (user) => (
      <Typography sx={{ fontSize: 12, color: '#656565', fontWeight: 400 }}>
        {user.email ? String(user.email) : '-'}
      </Typography>
    ),
    sortable: true,
    priority: 1
  },
  {
    name: 'first_name',
    header: {
      label: (ctx) => ctx.t('supervision.connected_users.table.first_name'),
    },
    value: (user) => (
      <Typography sx={{ fontSize: 12, color: '#656565', fontWeight: 400 }}>
        {user.first_name ? String(user.first_name) : '-'}
      </Typography>
    ),
    priority: 2
  },
  {
    name: 'last_name',
    header: {
      label: (ctx) => ctx.t('supervision.connected_users.table.last_name'),
    },
    value: (user) => (
      <Typography sx={{ fontSize: 12, color: '#656565', fontWeight: 400 }}>
        {user.last_name ? String(user.last_name) : '-'}
      </Typography>
    ),
    sortable: true,
    priority: 2
  },
  {
    name: 'total_consumption',
    header: {
      label: (ctx) => ctx.t('supervision.connected_users.table.consumption'),
    },
    value: (user) => (
      <Box>
        <Typography sx={{ fontSize: 12, color: '#656565', fontWeight: 400 }}>
          ↑ {formatBytes(Number(user.upload))}
        </Typography>
        <Typography sx={{ fontSize: 12, color: '#656565', fontWeight: 400 }}>
          ↓ {formatBytes(Number(user.download))}
        </Typography>
      </Box>
    ),
    sortable: true,
    priority: 3
  },
  {
    name: 'devices_count',
    header: {
      label: (ctx) => ctx.t('supervision.connected_users.table.devices_count'),
    },
    value: (user) => (
      <Typography sx={{ fontSize: 12, color: '#656565', fontWeight: 600 }}>
        {String(user.devices_count)}
      </Typography>
    ),
    sortable: true,
    priority: 2
  },
  {
    name: 'connected_since',
    header: {
      label: (ctx) => ctx.t('supervision.connected_users.table.connected_since'),
    },
    value: (user) => (
      <Typography sx={{ fontSize: 12, color: '#656565', fontWeight: 400 }}>
        {formatDateTime(String(user.connected_since))}
      </Typography>
    ),
    sortable: true,
    priority: 3
  }
];

export default COLUMNS_CONFIG;